import './index.css'
export default {
    props:['current'],
    render() {
        return (
            <div class="star-progress">
                <div class="light" style={{width:`${this.current}%`}}>
                    <div class="star"></div>
                    <div class="star"></div>
                    <div class="star"></div>
                    <div class="star"></div>
                    <div class="star"></div>
                </div>
                <div class="gray">
                    <div class="star"></div>
                    <div class="star"></div>
                    <div class="star"></div>
                    <div class="star"></div>
                    <div class="star"></div>
                </div>
            </div>
        )
    }
}